import { useQuery } from "react-query";
import { DashboardManutencao, ListarManutencaoQuery } from "../typings";
import http from "infra/http";
import { useRegrasTenant } from "core/features/tenants/tenants.context";

export function useDashboardManutencao(query: ListarManutencaoQuery) {
  const { useSubtenantsViews } = useRegrasTenant();

  return useQuery(
    [
      `/v1/manutencao/dashboard`,
      query.dataInicio,
      query.dataFim,
      query.search,
      query.tenantsIds,
      useSubtenantsViews,
    ],
    async () => {
      const { data } = await http.get<DashboardManutencao>(
        useSubtenantsViews
          ? "/v1/manutencao/dashboard/subtenants"
          : "/v1/manutencao/dashboard",
        { params: query }
      );
      return data;
    }
  );
}
